import React, { Component, ErrorInfo, ReactNode } from 'react';
import { Stack, Box, Button, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import styles from './styles';

type ErrorBoundaryProps = {
  children: ReactNode;
  fallback?: ReactNode;
  onReset?: () => void;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleRetry = (): void => {
    if (this.props.onReset) {
      this.setState({ hasError: false });
      this.props.onReset();
      return;
    }
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    if (this.props.fallback) {
      return this.props.fallback;
    }

    return (
      <Stack sx={styles.container} data-testid="error-boundary-fallback">
        <Box sx={styles.content}>
          <Box sx={styles.iconWrapper}>
            <ErrorOutlineIcon />
          </Box>
          <Typography sx={styles.message}>
            Something went wrong, please try again.
          </Typography>
          <Button onClick={this.handleRetry}>Try again</Button>
        </Box>
      </Stack>
    );
  }
}

export default ErrorBoundary;
